import keyMirror from "ramda-extension/es/keyMirror";
export const actionTypes = keyMirror({
    ADD_TOAST: null,
    REMOVE_TOAST: null
});
export const REDUCER_NAME = 'toastr';
export default {
    actionTypes
};
